export function parseBooleanAttr(attr) {
  // If it's defined but has no value, we count that as `true`.
  return attr !== undefined && attr !== 'false';
}
export function parseDateAttr(attr) {
  return attr ? new Date(attr) : undefined;
}
export function parseIntegerAttr(attr) {
  if (attr !== undefined) return parseInt(attr);
}
export function parseJsonAttr(attr) {
  const isJsonString = str => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
  return isJsonString(attr) ? JSON.parse(attr) : attr;
}